import React from "react";
import styled, { css } from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

export const CommentSplitUp = ({ data }) => {
  const { comments } = data;

  return (
    <>
      <Container>
        <SubContainer>
          <BasicDetailsLabel>Comments</BasicDetailsLabel>
          <BasicDetailsValue>{comments ? comments : "-"}</BasicDetailsValue>
        </SubContainer>
      </Container>
    </>
  );
};

export const BasicDetailsLabel = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10px;
  line-height: 1.7;
  color: ${COLORS.INPUT_LABEL};
  text-transform: capitalize;
`;

export const BasicDetailsValue = styled.div`
  word-break: break-all;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
  ${({ transform }) =>
    transform &&
    css`
      text-transform: ${transform};
    `}
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 780px) {
    margin: 30px 0 30px 10px;
    flex-wrap: nowrap;
  }
`;

const SubContainer = styled.div`
  width: 50%;
  margin-bottom: 25px;

  padding-left: 28px;
  &:nth-child(even) {
    padding-left: 18px;
    text-align: center;
  }
  &:nth-child(5) {
    margin-bottom: 0;
  }
  @media (min-width: 780px) {
    width: auto;
    margin: 0 30px;
    padding: 0;
    text-align: start;
    &:nth-child(even) {
      padding: 0;
      text-align: start;
    }
  }
`;
